import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const AddPurchaseOrderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .content {
    width: 100%;
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 0 16px;
      overflow-x: hidden;
      width: 100%;
      box-sizing: border-box;
    `}
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100% !important;
  }

  .horizontal-direction {
    display: flex;
    flex-direction: row;
    gap: 8px;
    ${responsive.MOBILE`
      align-items: center;
    `}
  }

  .currency-container {
    width: 132px;
  }

  .currency-container-textfield {
    width: calc(100% - 132px);
    ${responsive.MOBILE`
      padding-bottom: 0;
    `}
  }

  .notes-container {
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding-bottom: 24px;
    margin-top: 40px;
    ${responsive.MOBILE`
      margin-top: 16px;
      padding-bottom: 16px;
      grid-template-columns: 1fr;
    `}
    .notes-input {
      .MuiInputBase-root {
        height: 100px;
        background: ${COLORS.cirrus_black1};
        padding: 0px;
      }
    }
  }
`;
